import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import ReactCursorPosition from "react-cursor-position";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import classNames from "classnames";

import SplitPane, {Pane} from 'react-split-pane';

import {
  setPdfPage,
  setPdfScale,
  setCanvasMarginLeft,
  setCanvasDimensions,
  setCanvasCurrentPageOriginalDimensions, setPdfTotalPage, setPdfTotalPages
} from "./components/pdfViewer/actions.jsx";
import { getTemplate } from "./components/template/actions";
import PageLoader from "./components/pageLoader/PageLoader.jsx";
import TemplateSettingsModal from "./components/modals/TemplateSettingsModal.jsx";
import EditTemplateModal from "./components/modals/EditTemplateModal.jsx";
import MacrosModal from "./components/modals/MacrosModal.jsx";
import SelectGridCellModal from "./components/modals/SelectGridCellModal.jsx";

import RunTemplateResult from "./components/windows/RunTemplateResult";
import RunObjectResult from "./components/windows/RunObjectResult";
import PdfViewer from "./components/pdfViewer/PdfViewer.jsx";
import Dashboard from "./components/dashboard/Dashboard.jsx";
import "./Home.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-widgets/dist/css/react-widgets.css";
import { matchPath } from "react-router-dom";
import Guide from "./components/guide/guide.js";
import GuidelinesModal from "./components/guidelinesModal/GuidelinesModal";
import { VERSION } from "./version";
import { isNil } from "ramda";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCoins } from "@fortawesome/free-solid-svg-icons";

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      unloadAlert: true,
      sidebarCollapse: true,
      isOpenSampleTemplatesModal: false,
    };

    this.handleExpandSidebar = this.handleExpandSidebar.bind(this);
    this.handleCollapseSidebar = this.handleCollapseSidebar.bind(this);
  }

  setOpenSampleTemplatesModal = (data) => {
    this.setState({
      isOpenSampleTemplatesModal: data
    });
  }

  handleOpenSampleTemplate = () => {
    if (this.props.isTemplateModified && !window.confirm("Are you sure you want to discard all changes in the current template without saving?")) {
      return;
    }
    this.setOpenSampleTemplatesModal(true);
  };

  disableUnloadAlert = () => {
    this.state.unloadAlert = false;
  };

  componentDidMount = () => {
    var self = this;

    window.addEventListener("beforeunload", function (e) {
      if (self.props.isTemplateModified && self.state.unloadAlert) {
        e.preventDefault();
        e.returnValue = "";
      }
    });

    if (
      !!matchPath(
        this.props.location.pathname,
        "/document-parser/templates/:id/editor"
      )
    ) {
      this.props.getTemplate(this.props.match.params.id);
    }
  };

  handleExpandSidebar(event) {
    this.setState({ sidebarCollapse: false });
  }

  handleCollapseSidebar(event) {
    this.setState({ sidebarCollapse: true });
  }

  getSizeOfPDFViewerPane = () => {
    if (this.props.runTemplateWindowOpened || this.props.runObjectWindowOpened) {
      return "50%";
    } else {
      localStorage.getItem('PDFcoDocumentParserResultplitPos')
    }
    return
  }

  render() {
    const windowOpened =
      this.props.runTemplateWindowOpened || this.props.runObjectWindowOpened;
    const pdfViewerWrapperClasses = classNames(
      `${"" // this.state.sidebarCollapse ? "col-lg-9" : "col-lg-6"
      } pdf-viewer-wrapper`,
      {
        divided: windowOpened,
      }
    );

    return (
      <div className="App">
        <div className="js-dashboard-menu-portal" />
        <div className="split-pane-wrapper">
          <SplitPane
            style={{maxHeight: "100%"}}
            defaultSize={parseInt(localStorage.getItem('PDFcoDocumentParserEditorsplitPos'), 10) || "450px"}
            onChange={(size) => localStorage.setItem('PDFcoDocumentParserEditorsplitPos', size)}
          >
            <div
              className={`${"" // this.state.sidebarCollapse ? "col-lg-3" : "col-lg-6"
                } dashboard-wrapper`}
            >
              <Dashboard
                isOpenSampleTemplatesModal={this.state.isOpenSampleTemplatesModal}
                setOpenSampleTemplatesModal={this.setOpenSampleTemplatesModal}
                disableUnloadAlert={this.disableUnloadAlert}
                handleEnterExpandArea={this.handleExpandSidebar}
                handleLeaveExpandArea={this.handleCollapseSidebar}
              />
            </div>
            <div className={pdfViewerWrapperClasses}>
              <SplitPane
                className="result-panes"
                style={{maxHeight: "100%"}}
                minSize={(!this.props.runTemplateWindowOpened && !this.props.runObjectWindowOpened) ?  "100%" : 50}
                maxSize={-50}
                size={(this.props.runTemplateWindowOpened || this.props.runObjectWindowOpened) ? "50%": "100%"}
                defaultSize={(!this.props.runTemplateWindowOpened && !this.props.runObjectWindowOpened) ? "100%" : "50%"}
                split="horizontal"
              >
                <div className="pdf-viewer">
                  <ReactCursorPosition
                    style={{height: "100%"}}
                    ref={(rcp) => (this.reactCursorPositionRef = rcp)}
                  >
                    <PdfViewer
                      handleOpenSampleTemplate={this.handleOpenSampleTemplate}
                      pdfFile={this.props.pdfFile}
                      pdfUrl={this.props.pdfUrl}
                      convertingToPdf={this.props.convertingToPdf}
                      setPdfPage={this.props.setPdfPage}
                      setPdfTotalPages={this.props.setPdfTotalPages}
                      setPdfScale={this.props.setPdfScale}
                      currentEditorPage={this.props.page}
                      currentEditorScale={this.props.scale}
                      setCanvasMarginLeft={this.props.setCanvasMarginLeft}
                      setCanvasDimensions={this.props.setCanvasDimensions}
                      setCanvasCurrentPageOriginalDimensions={
                        this.props.setCanvasCurrentPageOriginalDimensions
                      }
                      canvasMarginLeft={this.props.canvasMarginLeft}
                      canvasWidth={this.props.canvasWidth}
                      canvasHeight={this.props.canvasHeight}
                      currentPageOriginalHeight={
                        this.props.currentPageOriginalHeight
                      }
                      currentPageOriginalWidth={this.props.currentPageOriginalWidth}
                      currentPageOriginalRotationAngle={
                        this.props.currentPageOriginalRotationAngle
                      }
                      reactCursorPositionRef={this.reactCursorPositionRef}
                      isTemplateModified={this.props.isTemplateModified}
                      isCustomFile={this.props.isCustomFile}
                      remainingCredits={this.props.remainingCredits}
                    />
                  </ReactCursorPosition>
                </div>

                <div style={{height: "100%", background: "#d3dedc"}}>
                  {this.props.runTemplateWindowOpened && <RunTemplateResult />}
                  {this.props.runObjectWindowOpened && <RunObjectResult />}
                </div>

              </SplitPane>
            </div>
          </SplitPane>
        </div>

        <TemplateSettingsModal />
        <EditTemplateModal />
        <MacrosModal />
        <SelectGridCellModal />

        <PageLoader />
        <div className="guide">
          <GuidelinesModal />
        </div>


          <div className="HomeFooterWrap">
            <div className="remainingCreditsWrap">
              {!isNil(this.props.remainingCredits) && (
                <a href="https://app.pdf.co/subscriptions" target="_blank" className='text-muted'>
                  <span className="title">
                    <FontAwesomeIcon icon={faCoins} className="icon" />
                    Remaining Credits:{" "}
                  </span>
                  <span className="value">
                    {this.props.remainingCredits.toLocaleString("en-US")}
                  </span>
                </a>
              )}
            </div>
            <div className="TextWrap">
              To see API calls details, press{" "}
              <span className="text-primary fw-bold mx-lg-1">
                  Ctrl+Shift+J{" "}
                </span>
              to show Developer Console
            </div>
            <div className="VersionWrap">v{VERSION}</div>
          </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    pdfFile: state.pdfViewer.file,
    pdfUrl: state.pdfViewer.url,
    page: state.pdfViewer.page,
    scale: state.pdfViewer.scale,
    convertingToPdf: state.pdfViewer.convertingToPdf,
    canvasMarginLeft: state.pdfViewer.canvasMarginLeft,
    canvasWidth: state.pdfViewer.canvasWidth,
    canvasHeight: state.pdfViewer.canvasHeight,
    currentPageOriginalHeight: state.pdfViewer.currentPageOriginalHeight,
    currentPageOriginalWidth: state.pdfViewer.currentPageOriginalWidth,
    currentPageOriginalRotationAngle:
      state.pdfViewer.currentPageOriginalRotationAngle,
    runTemplateWindowOpened: state.windows.runTemplateWindowOpened,
    runObjectWindowOpened: state.windows.runObjectWindowOpened,
    isTemplateModified: state.editor.isTemplateModified,
    pdfFileName: state.pdfViewer.pdfFileName,
    templateFileName: state.editor.templateFileName,
    isCustomFile: state.pdfViewer.isCustomFile,
    remainingCredits: state.dashboard.remainingCredits
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setPdfPage,
      setPdfTotalPages,
      setPdfScale,
      setCanvasMarginLeft,
      setCanvasDimensions,
      setCanvasCurrentPageOriginalDimensions,
      getTemplate,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
